import { IAlertProps, IAlertsService, IConfirmProps, INotificationProps } from '../alerts';

interface IAlertsServiceHost {
    showAlert: (props: IAlertProps) => string;
    showConfirm: (props: IConfirmProps) => string;
    closeAlert: (alertKey: string) => void;
    showNotification?: (NotificationProps: INotificationProps) => string;
    closeNotification?: (alertKey: string) => void;
    closeEventNotifications?: () => void;
}

/**
 * implementation of alerts service, which utilize host component for showing alerts and acts literally as a proxy
 * to component implementing IAlertsServiceHost
 * in order to let IAlertsService being resolved as a service
 */
class AlertsService extends IAlertsService {
    private host: IAlertsServiceHost;

    public setAlertsHost(host: IAlertsServiceHost) {
        this.host = host;
    }

    public alert(alertProps: IAlertProps) {
        return this.host.showAlert(alertProps);
    }

    public confirm(confirmProps: IConfirmProps) {
        return this.host.showConfirm(confirmProps);
    }

    public closeAlert(alertKey: string) {
        this.host.closeAlert(alertKey);
    }

    public notification(notificationProps: INotificationProps) {
        return this.host.showNotification(notificationProps);
    }

    public closeNotification(alertKey: string) {
        return this.host.closeNotification(alertKey);
    }

    public closeEventNotifications() {
        return this.host.closeEventNotifications();
    }
}

export { AlertsService, IAlertsServiceHost };
